export default __webpack_public_path__ + "static/media/kids4.801b813c.jpg";